import { render, staticRenderFns } from "./XourcesTable.vue?vue&type=template&id=0d0cc2e0&"
import script from "./XourcesTable.vue?vue&type=script&lang=js&"
export * from "./XourcesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports